import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, Input, ChangeDetectorRef, OnChanges, Output, EventEmitter, ElementRef, Renderer2 } from '@angular/core';
import { ExtrasFlightComponent } from '@ibe.components/booking/extras/extras-flight/extras-flight.component';
import { INDRABookedTripDetails, INDRAFareInformation } from '@ibe.models/booked-trip-details.indra.model.lib';
import { SidebarService } from '@ibe/services/ui';
import {
	STATUS_CODE_CANCELLED,
	STATUS_BOOK_PENDING_CODE,
	CHECK_IN_STATUS_CLOSED,
	CHECK_IN_STATUS_INVALID,
	CHECK_IN_STATUS_OPEN,
	TRANSLATION_ANCILLARIES_TYPE,
	EXTRAS_ANCILLARY_SEAT,
	EXTRAS_ANCILLARY_BAG,
	EXTRAS_ANCILLARY_EQUIPMENT,
	EXTRAS_ANCILLARY_MEAL,
	EXTRAS_ANCILLARY_INSURANCE,
	EXTRAS_ANCILLARY_HOTEL,
	EXTRAS_ANCILLARY_CAR,
	EXTRAS_ANCILLARY_ANIMAL,
	EXTRAS_ANCILLARY_FAST_TRACK,
	EXTRAS_ANCILLARY_LOUNGE,
	EXTRAS_ANCILLARY_TOURS,
	EXTRAS_ANCILLARY_PERSONAL_ASSISTANCE,
	EXTRAS_ANCILLARY_PARKING,
	EXTRAS_ANCILLARY_CARBON_OFFSET,
	EXTRAS_ANCILLARY_GUARANTEE_FUND,
	TRANSLATION_ANCILLARY_GROUP,
	TRANSLATION_ALT,
	BRAND_CODE_EXECUTIVE,
	BRAND_CODE_DISCOUNT,
	BRAND_CODE_TOP_EXECUTIVE,
	SSR_CODE_SEAT,
	EXTRAS_ANCILLARY_MUSICAL,
	SSR_CODES_IGNORE_LIST,
	SSR_CODE_MILES_UPGRADE,
	SSR_CODE_PREMIUM_CUSTOMER_CENTER,
	LISBON_CODE,
	SSR_CODE_PLUSGRADE,
	CANCELLED_CODES,
	UNCONFIRMED_CODES,
	SSR_CODE_UNACCOMPANIED_MINOR,
	CODESHARE_HIDDEN_ANCILLARIES,
	SSR_CODE_FREQUENT_TRAVELLER_MILES_PROGRAM_REDEMPTION,
	ANCILLARY_PRODUCT_GROUP_CODE_PET_IN_CABIN,
	ANCILLARY_PRODUCT_GROUP_CODE_FAST_TRACK,
	ANCILLARY_PRODUCT_GROUP_CODE_LOUNGE,
	AWARD_RBD_LIST,
	EQUIPMENT_CODE_BUS,
	EQUIPMENT_CODE_TRAIN,
	ANCILLARIES_INELIGIBLE_FOR_CHANGE,
	ANCILLARY_PRODUCT_GROUP_CODE_MEAL,
	TAP_MILES_AND_GO_FF_TIER_LEVELS_HIERARCHY,
	SESSION_VAR_KEY_LANGUAGE,
	DEFAULT_LANGUAGE,
	SPECIAL_CASE_MARKET_LANGUAGE_MAP,
	SESSION_VAR_KEY_MARKET,
	DEFAULT_MARKET, ANCILLARY_PRODUCT_BAGGAGE, EXTRAS_ANCILLARY_PREF_BOARD
} from '@ibe.config';
import { INDRASegment } from '@ibe.models/segment.indra.model.lib';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { Observable, BehaviorSubject, Subscription, of, fromEvent } from 'rxjs';
import {
	INDRAFeature,
	PURCHASED_ANCILLARY_BAG,
	PURCHASED_ANCILLARY_SEAT,
	PURCHASED_ANCILLARY_EQUIPMENT,
	PURCHASED_ANCILLARY_EXTRA_FAST_TRACK,
	PURCHASED_ANCILLARY_EXTRA_ANIMAL,
	PURCHASED_ANCILLARY_EXTRA_MEAL,
	PURCHASED_ANCILLARY_EXTRA_LOUNGE,
	PURCHASED_ANCILLARY_EXTRA_MUSICAL,
	PURCHASED_ANCILLARY_PREF_BOARD
} from '@ibe.components/shared/flight-brand-features-list/features.indra';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRATotalSummaryService } from '@ibe.services/total-summary.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRATotalSummaryDetails } from '@ibe.models/total_summary.model';

import { Router } from '@angular/router';
import * as _ from 'lodash';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRAPackService } from '@ibe.components/shared/sidebar-views/ancillaries/pack/pack.service.indra';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRAAddOnAncillary } from '@ibe.models/ancillary.indra.model.lib';

// import { select, Store } from '@ngrx/store';
// import * as fromStore from '@ibe/store/index';

@Component({
	selector: 'app-extras-flight',
	templateUrl: './extras-flight.indra.component.html',
	styleUrls: ['./extras-flight.component.scss'],
	host: {
		class: 'ancillaries-flight'
	},
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class INDRAExtrasFlightComponent extends ExtrasFlightComponent
	implements OnInit, OnChanges, OnDestroy {

	@Input()
	flight: any;

	@Input()
	flight_extras: any[];

	@Input()
	bookingPacks: any[];

	@Input()
	booked_trip: INDRABookedTripDetails;

	@Input()
	show_check_in = true;

	@Input()
	loading_extras = true;

	/* note: client changes that were not merged
	@Input()
	showIncludedFeatures: boolean = true;

	@Input()
	extraInfo = true;
	*/

	@Input()
	extrasAdded: any = [];

	@Input()
	expanded: string = '';
	// expanded: string = 'expanded';

	@Input()
	upgradeInfo = true;

	@Input()
	editOrChangeInfo = true;

	@Input()
	isDupe?: boolean = false;

	@Output() setExtraFeatures = new EventEmitter<any>();

	private time_to_flight = 0;

	_flight: any;

	included_features = [];
	extra_features = [];
	dateDeparture: string;
	dataPnr: string;

	options;

	isCancelledFlight = false;

	totalSummary: INDRATotalSummaryDetails;

	flightStops: INDRASegment[] = [];
	commercialStops: INDRASegment[] = [];
	allStops: INDRASegment[] = [];
	flightBrand: any;

	// includedFeaturesIcons will be used on the checking if a certain feature has been added already on the previous iterations.
	includedFeaturesIcons = [];

	/* ignored ancillary list. there's a possibility that the ssr codes under this list will still be returned by the API
	but front end will not show these items. */
	ignoredAncillaryList: string[] = SSR_CODES_IGNORE_LIST;

	plusgradeFlag = false; // this will be utilized for detecting plusgrade UPGP ancillary
	hasUnaccompaniedMinor = false; // this will be utilized for detecting requested medical assistance on prm
	allAreUnaccompaniedMinor = false;
	IfAllPassengersAreChildren = false;
	isAwardTicket = false; // used for identifying if the current PNR is an award ticket
	hasPlusgradeEligibleRBD = false; // used for checking if the flight can be upgrade with plusgrade (depenging on the eligible RBD values)
	hasIssuedTicket = true;
	isUnavailableFlight = false;
	hasTotalSummary = false;
	tmp_pmrAncillaryList: string[] = [];

	extra_features_purchased = [];

	isEligibleForUpdateOrChange = true;
	noShow = false;

	allSubscriptions: Subscription[] = [];
	currentTotalSummarySubscription: Subscription;
	loadingTotalSummarySubscription: Subscription;
	sidebarConfirmedSubscription: Subscription;
	sidebarClosedSubscription: Subscription;
	translationSubscription1: Subscription;
	translationSubscription2: Subscription;
	translationSubscription3: Subscription;
	packSubscription: Subscription;

	breakdownAPIstatus = 'loading';
	isCheckInInfo: boolean = true;

	isBookingFlow: boolean = false; // Phase 2's Review your trip, TTT summary, booking view or payment page
	isTimeToThinkFlow: boolean = false; // TTT summary page
	isBookingViewFlow: boolean = false; // Booking view page
	isTimeToThinkCompletionFlow: boolean = false;  // Phase 2's Review your trip with TTT for booking completion

	// private timeToThink_to_booking$: Observable<Object> = this.store.select(fromStore.getSelectedBookedTripTTTCompletionDetails);
	// isTTTBokingPayment: boolean = false;

	dupeFlightAncillaries: any = [];
	flightDate: string = '';;
	timeUnitKey: string = ''
	timeUnitValue: number = 0;
	showTimeInfo: boolean = false;
	
	flight_packs: any[] = [];
	availablePacks: string[] = [];
	prevCurrentPacks: any[] = [];
	currentPacks: any[];
	shoppingCartSubscription: Subscription;
	ancillariesAdded: INDRAAddOnAncillary[];
	disabledPacks: string[];

	constructor(
		// private store: Store<fromStore.State>,
		private sidebarService: SidebarService,
		private changeDetector: ChangeDetectorRef,
		private dateService: INDRADateService,
		protected ibeAdminService: INDRAIbeAdminService,
		private bookingService: INDRABookingService,
		private totalSummaryService: INDRATotalSummaryService,
		private bookingSearchService: INDRABookingSearchService,
		protected router: Router,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		private packService: INDRAPackService,
		private renderer: Renderer2,
		private el: ElementRef,
		private ancillariesShoppingCart: INDRAAncillariesShoppingCartService,
		private cd: ChangeDetectorRef
	) {
		super();

		/*
		this.timeToThink_to_booking$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.isTTTBokingPayment = true;
				}
			});
		*/
	}

	ngOnInit() {
		// check if this component is used in booking flow (review your trip page, TTT summary page, and booking view page)
		if (this.router.url.includes('/review-your-trip') ||
			this.router.url.includes('/time-to-think') ||
			this.router.url.includes('/my-bookings/view') ||
			this.router.url.includes('/payment')) {
			this.isBookingFlow = true;
		}
		if (this.router.url.includes('/time-to-think')) {
			this.isTimeToThinkFlow = true;
		}
		if (this.router.url.includes('/review-your-trip/deeplink')) {
			this.isTimeToThinkCompletionFlow = true;
		}
		if (this.router.url.includes('/my-bookings/view')) {
			this.isBookingViewFlow = true;
		}
		if (this.bookingPacks && this.bookingPacks.length > 0) {
			this.bookingPacks.forEach(pack => {
				let packAvailableForFlight = false;
				pack.ancillaryList[0].catalog.forEach(item => {
					if (item.flightId.toString() === this.flight.details.idFlight.toString()) {
						packAvailableForFlight = true;
					}
				});
				if (!this.availablePacks.includes(pack.ancillaryList[0].type) && packAvailableForFlight) {
					this.availablePacks.push(pack.ancillaryList[0].type);
				}

				pack.ancillaryList[0].catalog.forEach(pck => {
					if (pck.flightId == this.flight.details.idFlight) {
						this.flight_packs.push({
							...pck,
							itemId: pack.ancillaryList[0].itemId,
							type: pack.ancillaryList[0].type
						});
					}
				});
			});


			// this.flight_packs = packs.reduce((acc, pack) => {
			// 	console.log("acc: ", acc);
			// 	if (!acc[pack.type]) {
			// 		console.log("not there, so creating for ", pack.type);
			// 		acc[pack.type] = [];
			// 	}


			// 	acc[pack.type].push(pack)
			// 	console.log("acc after: ", acc);

			// 	return acc;
			// })
		}
		this.sidebarConfirmedSubscription = this.sidebarService.sidebarConfirmed$.subscribe(value => {
			this.changeDetector.markForCheck();
		});

		this.sidebarClosedSubscription = this.sidebarService.sidebarClosed$.subscribe(value => {
			this.changeDetector.markForCheck();
		});

		// subscribe to changes in total summary object
		this.INDRA_initializeTotalSummarySubscription();

		if (this.flight) {
			this._flight = Object.assign({}, this.flight, { options: Object.assign({}, this.flight.options, { features: this.INDRA_getIncludedFeatures(this.flight.details.idFlight) }) });
			this.flightBrand = this._flight.options.features;
			// LINKS AT THE END OF FLIGHT CARD
			this.options = {
				upgrade: [],
				change_cancel: []
			};

			// this retrieves the features included for the fare family
			this.included_features = this._flight.options.features;

			// this adds the tier benefits of passengers with member programs..
			this.INDRA_getPassengersTierBenefits();

			// this adds the features that were purchased already for the flight.
			this.INDRA_updateIncludedFeaturesWithPurchasedFeature();

			// this adds seats for the flight.
			this.INDRA_updateIncludedFeaturesWithSeats();

			// this adds features included in PRM
			if (!this.isBookingFlow) this.INDRA_updateIncludedFeaturesWithPRM();

			// Temporarily added this condition to avoid getting errors for duplicate flights
			if (!this.isDupe) {
				// this add miles earned and FF program tier level entry per applicable passenger
				this.INDRA_updateIncludedFeaturesWithMilesAndFFProgram();
			}

			// check if flight has an Plugrade Upgrade-eligible RBD
			if (!this.isBookingFlow) this.hasPlusgradeEligibleRBD = this.INDRA_checkIfPlugradeEligibleRBD();

			// check if PNR has an issued ticket/s (if no ticket, change flight and upgrades are not allowed)
			if (!this.isBookingFlow) this.hasIssuedTicket = this.bookingService.INDRA_checkIfPNRIssuedTickets();

			// this.isUnavailableFlight = this.INDRA_isUnavailableFlight(this.flight.details.idFlight);

			// check if any of the segments of the flight has a no-show
			if (!this.isBookingFlow) this.INDRA_checkNoShowFlight();

			if (!this.isBookingFlow && this.bookingService.INDRA_isTAPGDSOffice(this.booked_trip.data.office)) {

				// *** UPGRADE ** //
				if (this.isEligibleForUpdateOrChange && this.hasIssuedTicket) {

					// * Upgrade with cash
					if (!this.booked_trip.data.group) {
						if (this.INDRA_getBrand() !== '' &&
							this.INDRA_getBrand() !== BRAND_CODE_TOP_EXECUTIVE &&
							this.INDRA_getBrand() !== BRAND_CODE_DISCOUNT &&
							!this.isAwardTicket) {
							this.options.upgrade.push({
								label: this.INDRA_getTranslation('bookingDetails.link.upgradeWithCash'),
								link: '/my-bookings/upgrade-with-cash/' + this.booked_trip.data.pnr,
								queryParams: { flight: this.flight.details.assignedFlightId }
							});
						}
					}

					// * Upgrade with miles
					if (this.INDRA_getBrand() !== BRAND_CODE_EXECUTIVE && !this.isAwardTicket) {
						this.options.upgrade.push({
							label: this.INDRA_getTranslation('bookingDetails.link.upgradeWithMiles'),
							link: '/my-bookings/upgrade-with-miles/' + this.booked_trip.data.pnr,
							queryParams: { flight: this.flight.details.idFlight }
						});
					}

					// * Bid your Upgrade with Plusgrade
					if (this.INDRA_getBrand() !== BRAND_CODE_EXECUTIVE || this.hasPlusgradeEligibleRBD) {
						this.options.upgrade.push({
							label: this.INDRA_getTranslation('bookingDetails.link.upgradeWithPlusgrade'),
							urlExternal: 'externalURLs.upgradeWithPlusgrade',
							classes: 'link--external'
						});
					}


					// *** EDIT OR CHANGE ** //
					// * Change flight schedule or date
					// * Cancel and request refund
					if (!this.booked_trip.data.group) {
						if (this.booked_trip.data.atcAllow && !this.isAwardTicket && !this.INDRA_segmentHasTrainBus()) {
							this.options.change_cancel.push({
								label: this.INDRA_getTranslation('bookingDetails.link.changeFlightSchedule'),
								link: '/my-bookings/change-flight/search/' + this.booked_trip.data.pnr,
								queryParams: { flight: this.flight.details.idFlight }
							});
						}
					}
				}

				// *** CANCEL ** //
				// * Cancel flight
				this.options.change_cancel.push({
					label: this.INDRA_getTranslation('bookingDetails.link.cancelFlights'),
					link: '/my-bookings/cancel-booking/' + this.booked_trip.data.pnr
				});
			}
		}

		if (this.flight_extras && this.flight_extras.length > 0)
			this.INDRA_loadExtras();

		this.isCancelledFlight = this.INDRA_checkIfCancelled();

		// Fetched necessary details of the flight
		this.flight.details.listSegment.forEach(segment => {
			// find layover flights
			if (segment.stopTime > 0 && !segment.stopover) {
				this.flightStops.push(segment);
				this.allStops.push(segment);
			} else if(segment.technicalStops != null){
				if (segment.technicalStops.length > 0){
					this.commercialStops.push(segment);
					this.allStops.push(segment);
				}	
			}
		});

		if (this.isCancelledFlight) {
			this.INDRA_getExtrasPurchased();
		}

		this.dataPnr = this.booked_trip.data.pnr;

		this.shoppingCartSubscription = this.ancillariesShoppingCart.INDRA_getAncillariesShoppingCart(this.dataPnr).subscribe(
			result => {
				if (this.flight) {
					this.ancillariesAdded = [];
					this.disabledPacks = [];

					result.itemsAdded.forEach((item) => {
						if (item.enabled === true && (
							item.flightCardId === this.flight.details.assignedFlightId.toString()
						)) {
							if (!this.ancillariesAdded.some(ancillary => (ancillary.code === item.code) && (ancillary.segmentId === item.segmentId))) {
								this.ancillariesAdded.push(item);	
							}

							this.flight_packs.forEach((flight_pack) => {
								const itemCode = flight_pack.type;
								const packAncillaries = flight_pack.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription;

								// Means the added item is a pack
								if (itemCode === item.code) {
									packAncillaries.forEach(p => {
										if (!this.ancillariesAdded.some(ancillary => (ancillary.code === p.code) && (ancillary.segmentId === flight_pack.segmentId))) {
											let packAncillary = {...p, segmentId: item.segmentId}
											this.ancillariesAdded.push(packAncillary);	
										}
									});
								}
							})
						}
					});

					if (this.ancillariesAdded.length > 0) {
						// Disable unavailable packs
						let availableFlightPacks = [...this.flight_packs];
						this.flight_packs.forEach((flight_pack) => {
							const itemCode = flight_pack.type;
							const packAncillaries = flight_pack.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription;

							packAncillaries.forEach(anc => {
								if (this.ancillariesAdded.some(ancillary => (ancillary.code === anc.code) && (ancillary.segmentId === flight_pack.segmentId))) { 
									// One of the pack ancillaries matches added ancillary, must check segments match to disable
									if (!this.disabledPacks.includes(itemCode)) {
										let index = availableFlightPacks.findIndex(pack => pack.type === itemCode && pack.segmentId === flight_pack.segmentId);
										if (index !== -1) {
											// If the pack segment matches ancillary segment or pack is flightBased, disable it
											// Ensure pack is not available in any segments before disabling
											availableFlightPacks.splice(index, 1);
											if (!availableFlightPacks.some(pack => pack.type === itemCode) || flight_pack.flightBased) {
												this.disabledPacks.push(itemCode);
											}
										}
									}
								}
							});
						});
					}

					this.changeDetector.detectChanges();
				}
			}
		);

		this.allSubscriptions.push(this.sidebarConfirmedSubscription);
		this.allSubscriptions.push(this.sidebarClosedSubscription);
		this.allSubscriptions.push(this.shoppingCartSubscription);

		if (this.isDupe && this.extrasAdded.length != 0) {
			this.dupeFlightAncillaries = _.cloneDeep(this.extrasAdded);
			for (const i in this.dupeFlightAncillaries) {
				this.dupeFlightAncillaries[i].journey = this.dupeFlightAncillaries[i].journey.find(item => item.flightId == this.flight.details.idFlight && item.assignedFlightId == this.flight.details.assignedFlightId);
			}

			this.dupeFlightAncillaries = this.dupeFlightAncillaries.filter(item => item.journey);
		}
	}

	ngAfterViewInit() {
		this.INDRA_getTimeInfo();
		this.packSubscription = this.packService.currentPacks.subscribe(value => {
			//A pack has been deselected
			if (this.prevCurrentPacks.length > value.length) {
				this.prevCurrentPacks.filter(pack => !value.some(pck => pck.flightId == pack.flightId && pck.type == pack.type)).forEach(pck => {
					let packElement = this.el.nativeElement.querySelector(`#${pck.passengers[0].codeList[0].code}_${pck.flightId}`);
					if (packElement && packElement.classList.contains('selected')) {
						this.renderer.removeClass(packElement, 'selected');
					}
				});
				this.prevCurrentPacks = value;
			//A pack has been selected
			} else {
				// value[0].filter(pack => !this.prevCurrentPacks.some(pck => pck.flightId == pack.flightId && pck.type == pack.type)).forEach(pck => {
				// 	let packElement = this.el.nativeElement.querySelector(`#${pck.passengers[0].codeList[0].code}_${pck.flightId}`);
				// 	if (packElement) {
				// 		this.renderer.addClass(packElement, 'selected');
				// 	}
				// });
				this.prevCurrentPacks = value;
			}			
		});
	}

	ngOnChanges() {
		if (this.flight_extras && this.flight_extras.length > 0) {
			this.INDRA_loadExtras();
		}
	}

	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
			sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
			sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}

	INDRA_segmentHasTrainBus() {
		let returnVal = false;
		this.flight.details.listSegment.forEach((segment) => {
			if (segment.equipment === EQUIPMENT_CODE_BUS || segment.equipment === EQUIPMENT_CODE_TRAIN) {
				returnVal = true;
			}
		});
		return returnVal;
	}

	private INDRA_loadExtras() {
		this.extra_features = [];
		this.flight_extras.forEach(extra => {
			// if (this.bookingService.INDRA_checkIfCodeShare(this.flight.details.listSegment) && CODESHARE_HIDDEN_ANCILLARIES.includes(extra)) {
			// 	return;
			// } else {
			switch (extra) {
				case EXTRAS_ANCILLARY_BAG:
					this.applyTranslations(PURCHASED_ANCILLARY_BAG, extra);
					break;
				case EXTRAS_ANCILLARY_SEAT:
					this.applyTranslations(PURCHASED_ANCILLARY_SEAT, extra);
					break;
				case EXTRAS_ANCILLARY_EQUIPMENT:
					this.applyTranslations(PURCHASED_ANCILLARY_EQUIPMENT, extra);
					break;
				case EXTRAS_ANCILLARY_MEAL:
					if (!this.INDRA_checkIfAllPassengersAlreadyPurchasedForAncillaryGroup(ANCILLARY_PRODUCT_GROUP_CODE_MEAL)) {
						this.applyTranslations(PURCHASED_ANCILLARY_EXTRA_MEAL, extra, true);
					}
					break;
				case EXTRAS_ANCILLARY_INSURANCE: break;
				case EXTRAS_ANCILLARY_HOTEL: break;
				case EXTRAS_ANCILLARY_CAR: break;
				case EXTRAS_ANCILLARY_TOURS: break;
				case EXTRAS_ANCILLARY_PERSONAL_ASSISTANCE: break;
				case EXTRAS_ANCILLARY_PARKING: break;
				case EXTRAS_ANCILLARY_CARBON_OFFSET: break;
				case EXTRAS_ANCILLARY_GUARANTEE_FUND: break;
				case EXTRAS_ANCILLARY_ANIMAL:
					if (!this.INDRA_checkIfAllPassengersAlreadyPurchasedForAncillaryGroup(ANCILLARY_PRODUCT_GROUP_CODE_PET_IN_CABIN)) {
						this.applyTranslations(PURCHASED_ANCILLARY_EXTRA_ANIMAL, extra);
					}
					break;
				case EXTRAS_ANCILLARY_FAST_TRACK:
					if (!this.INDRA_checkIfAllPassengersAlreadyPurchasedForAncillaryGroup(ANCILLARY_PRODUCT_GROUP_CODE_FAST_TRACK)) {
						this.applyTranslations(PURCHASED_ANCILLARY_EXTRA_FAST_TRACK, extra);
					}
					break;
				case EXTRAS_ANCILLARY_LOUNGE:
					if (!this.INDRA_checkIfAllPassengersAlreadyPurchasedForAncillaryGroup(ANCILLARY_PRODUCT_GROUP_CODE_LOUNGE)) {
						this.applyTranslations(PURCHASED_ANCILLARY_EXTRA_LOUNGE, extra);
					}
					break;
				case EXTRAS_ANCILLARY_MUSICAL:
					this.applyTranslations(PURCHASED_ANCILLARY_EXTRA_MUSICAL, extra);
					break;
				case EXTRAS_ANCILLARY_PREF_BOARD:
					this.applyTranslations(PURCHASED_ANCILLARY_PREF_BOARD, 'PREFBOARD');
					break;
			}
			// }
		});

		this.setExtraFeatures.emit(this.extra_features);
	}

	applyTranslations(feature: any, extra: string, useAltLabel: boolean = false) {
		let translatedFeature = feature;
		let aggregateSale = null;
		const translationKey = TRANSLATION_ANCILLARIES_TYPE + (useAltLabel ? TRANSLATION_ALT : '') + extra;
		translatedFeature.label = this.INDRA_getTranslation(translationKey);
		translatedFeature.labelKey = translationKey;
		const actionLabel: string = translatedFeature.action.label.toString();
		if (actionLabel.toLowerCase() === 'add') {
			// translatedFeature.action.label = this.INDRA_getTranslation('bookingDetails.button.add');
			translatedFeature.action.label = 'bookingDetails.button.add';
		} else if (actionLabel.toLowerCase() === 'choose') {
			// translatedFeature.action.label = this.INDRA_getTranslation('bookingDetails.button.choose');
			translatedFeature.action.label = 'bookingDetails.button.choose';
		}

		translatedFeature = Object.assign({}, translatedFeature, {
			flightDetails: {
				idFlight: this.flight.details.idFlight,
				assignedFlightId: this.flight.details.assignedFlightId,
				idFlightAvail: this.flight.details.idFlightAvail
			}
		});
		aggregateSale = this.bookingService.INDRA_getAggregateSaleForTypeAndFlight(extra, this.flight.details);

		if (aggregateSale && aggregateSale != null) {
			translatedFeature.action.aggregateSale = aggregateSale;
		}

		this.extra_features.push(translatedFeature);
	}



	ngOnDestroy() {
		for (const sub of this.allSubscriptions) {
			if (sub) {
				sub.unsubscribe();
			}
		}
	}

	INDRA_printAriaFlight() {
		return (
			this.flight.departureLocation.city +
			// ' flight, to ' +
			this.INDRA_getTextTranslation('bookingDetails.aria.flightTo') +
			this.flight.arrivalLocation.city
		);
	}

	INDRA_printFlightDate(flight: any): string {
		return flight ? this.dateService.INDRA_formatDate(flight.details.listSegment[0].departureDate, 'ddd, MMM D, YYYY') : '';
	}

	INDRA_dateInfo(flight: any): string {
		return flight ? this.dateService.INDRA_formatDate(flight.details.listSegment[0].departureDate, 'DD/MM/YYYY') : '';

	}

	INDRA_printTimeTo(): number {
		const timediff = this.time_to_flight;
		const days = Math.floor(this.dateService.INDRA_computeDifferenceOfDatesWithoutTimeInDays(new Date().toDateString(), this.flight.details.listSegment[0].departureDate));
		const hours = Math.floor(timediff / 60 / 60);
		const minutes = Math.floor(timediff / 60);
		if (days > 0) {
			return days;
		} else if (hours > 0) {
			return hours;
		} else if (minutes > 0) {
			return minutes;
		} else {
			return 0;
		}
	}

	INDRA_getTimeUnitKey(time: number): string {
		const timediff = time;
		const days = Math.floor(this.dateService.INDRA_computeDifferenceOfDatesWithoutTimeInDays(new Date().toDateString(), this.flight.details.listSegment[0].departureDate));
		const hours = Math.floor(timediff / 60 / 60);
		const minutes = Math.floor(timediff / 60);
		if (days > 0) {
			return 'bookingDetails.label.days';
		} else if (hours > 0) {
			return 'bookingDetails.label.hours';
		} else if (minutes > 0) {
			return 'bookingDetails.label.minutes';
		} else {
			return '';
		}
	}

	public INDRA_getTimeTo(): number {
		return this.flight ? this.dateService.INDRA_getRemainingTimeInSeconds(this.flight.details.listSegment[0].departureDate) : 0;
	}

	/*
	 *	Returns the RBD value for the current flight object

	 *	Assumption: For a flight, all RBDs are the same (cannot book segments with two different RBDs)
	 * 	thus it is okay to get the RBD value from the first segment
	 */
	INDRA_getRBD() {
		let segmentRBD = '';
		if (this.flight.details.listSegment && this.flight.details.listSegment[0]) {
			segmentRBD = this.flight.details.listSegment[0].rbd;
		}
		return segmentRBD;
	}

	INDRA_checkIfPlugradeEligibleRBD() {

		const segmentRBD = this.INDRA_getRBD();
		return AWARD_RBD_LIST.includes(segmentRBD);
	}

	INDRA_getIncludedFeatures(flightId: string) {
		const features = [];
		let includedFeature = null;
		let fareInformation: any;
		let ancClone = null;

		fareInformation = this.booked_trip['fare-information'];
		let flightIdfareInformation: INDRAFareInformation = fareInformation[flightId];

		if (flightIdfareInformation) {
			flightIdfareInformation = this.INDRA_checkForAncillariesPerSegment(flightIdfareInformation);

			// If meals and snack is available, meals will be priority. 
			ancClone = flightIdfareInformation.ancillaries;
			const containsSnack = flightIdfareInformation.ancillaries.includes("SNACK");
			const containsMeals = flightIdfareInformation.ancillaries.includes("MEALS");

			if (containsSnack && containsMeals) {
				const snackIndex = ancClone.indexOf("SNACK");
				const mealsIndex = ancClone.indexOf("MEALS");
				if (snackIndex < mealsIndex) {
				  [ancClone[snackIndex], ancClone[mealsIndex]] = [ancClone[mealsIndex], ancClone[snackIndex]];
				  flightIdfareInformation.ancillaries = ancClone;
				}
			}
			flightIdfareInformation.ancillaries.forEach(ancillaryCode => {
				// skip ancillary items that belongs to the ignore list.
				if (!this.ignoredAncillaryList.includes(ancillaryCode)) {
					includedFeature = INDRAFeature.createByCode(ancillaryCode, (this.isBookingFlow && !this.isBookingViewFlow && !this.isTimeToThinkCompletionFlow));

					if (!includedFeature.unconfirmed) {
						includedFeature = Object.assign({}, includedFeature, { unconfirmed: [] });
					}

					if (includedFeature.icon != 'general--not_available') {
						const labelKey = `${TRANSLATION_ANCILLARY_GROUP + ancillaryCode}`;
						includedFeature.label = this.INDRA_getTranslation(labelKey);
						includedFeature.details.label = this.INDRA_getTranslation('bookingDetails.link.learnMore');
					} else {
						includedFeature.label = new BehaviorSubject(includedFeature.label);
						includedFeature.details.label = this.INDRA_getTranslation('bookingDetails.link.learnMore');
					}

					if (!this.includedFeaturesIcons.includes(includedFeature.icon) || includedFeature.icon === 'general--not_available') {
						if (ancillaryCode === SSR_CODE_PREMIUM_CUSTOMER_CENTER) {
							if (this.INDRA_getBrand() === BRAND_CODE_TOP_EXECUTIVE || this.INDRA_getBrand() === BRAND_CODE_EXECUTIVE) {
								for (const segment of this.flight.details.listSegment) {
									if (segment.departureAirport === LISBON_CODE) {
										this.includedFeaturesIcons.push(includedFeature.icon);
										features.push(includedFeature);
										break;
									}
								}
							}
						} else {
							this.includedFeaturesIcons.push(includedFeature.icon);
							features.push(includedFeature);
						}
					}
				}


				// this detects if the flight has a plusgade ancillary.
				if (ancillaryCode === SSR_CODE_PLUSGRADE) {
					this.plusgradeFlag = true;
				}

				switch (this.INDRA_getBrand()) {
					case BRAND_CODE_TOP_EXECUTIVE:
					case BRAND_CODE_EXECUTIVE:
						if (includedFeature && includedFeature.id == 'extraseat') {
							includedFeature.valueLabelForComfortSeat = this.INDRA_getTextTranslation('whatsIncludedSidebars.text.freeSeatReservation');
						}
						break;
					default:
						// Update the values of economy extra to comfort seat
						if ((flightIdfareInformation['economy-extra-elegible'] && includedFeature.id == 'extraseat')) {
							includedFeature.icon = 'plane_related--tap_executive';
							includedFeature.valueLabelForComfortSeat = this.INDRA_getTextTranslation('availability.flightsPage.text.comfortseatreservation');
						}
						break;
				}
			});
		}

		return features.slice();
	}

	INDRA_checkForAncillariesPerSegment(flightIdfareInformation) {
		let ancillaries = [];
		let fareInformation = flightIdfareInformation;
		if (flightIdfareInformation.ancillariesBySegment && Object.keys(flightIdfareInformation.ancillariesBySegment).length) {
			const ancBySegment = flightIdfareInformation.ancillariesBySegment;
			Object.keys(ancBySegment).forEach(segment => {
				const segmentAncillaries = ancBySegment[segment];
				if (segmentAncillaries && segmentAncillaries.length) {
					segmentAncillaries.forEach(anc => {
						if (!flightIdfareInformation.ancillaries.includes(anc)) {
							ancillaries.push(anc);
						}
					});
				}
			});

			if (ancillaries && ancillaries.length) {
				// add ancillaries that are not in all segments to show on what's included section
				const allAncillaries = flightIdfareInformation.ancillaries.concat(ancillaries);
				fareInformation.ancillaries = [...allAncillaries];
			}
		}
		return fareInformation;
	}

	INDRA_printFlightTagStyle() {
		return {
			'tag--cancelled': this.isCancelledFlight,
			/* TODO 'tag--update': this.flight.update, temporarily turned this off to lessen the breaks while models are being updated*/
			'tag--flown': this._flight.details.flightFlown || this.noShow
		};
	}

	INDRA_printFlightTag() {
		if (this.noShow) {
			return 'bookingDetails.label.noShow';
		} else if (this._flight && this._flight.details.flightFlown) {
			return 'bookingDetails.label.flown';
		} else if (this.isCancelledFlight) {
			return 'bookingDetails.label.cancelled';
		} else {
			return false;
		}
	}

	INDRA_checkNoShowFlight() {
		// this.noShow = false;
		if (this._flight && this._flight.details.listSegment.length > 0) {
			if (this._flight.details.listSegment.map(value => value.noShow).filter(value => value === true).length > 0) {
				this.noShow = true;
			}
		}

		return this.noShow;
	}

	INDRA_checkCancelledFlight() {
		const listSegment = this._flight.details.listSegment;
		const cancelFlag = false;

		for (let i = 0; i < listSegment.length; i++) {
			const status = listSegment[i].status;
			if (!status) {
				continue;
			}

			if (status.includes(STATUS_CODE_CANCELLED)) {
				return true;
			}
		}

		return cancelFlag;
	}

	INDRA_checkIfCancelled() {
		let returnValue = false;
		const cancelCodes = CANCELLED_CODES;
		const listSegment = this._flight.details.listSegment;
		listSegment.forEach(
			(segment) => {
				// tslint:disable-next-line:radix
				const status = parseInt(segment.status[0]);
				for (const code of cancelCodes) {
					if (status === code) {
						returnValue = true;
						break;
					}
				}
			}
		);
		return returnValue;
	}

	INDRA_ariaLabelFlightTag() {
		if (this._flight.details.flightFlown) {
			// return 'Flight flown';
			this.INDRA_getTextTranslation('bookingDetails.aria.flightFlown');
		} else if (this.isCancelledFlight) {
			// return 'Flight cancelled';
			this.INDRA_getTextTranslation('bookingDetails.aria.flightCancelled');
		} else if (this._flight.update === 'new-flight') {
			// return 'This is a new flight';
			this.INDRA_getTextTranslation('bookingDetails.aria.thisIsANewFlight');
		} else if (this._flight.update === 'schedule-update') {
			// return 'Flight schedule Update';
			this.INDRA_getTextTranslation('bookingDetails.aria.flightScheduleUpdate');
		} else {
			return false;

		}
	}

	/**
	 * Returns stops
	 * @returns stops object
	 */
	INDRA_getStops() {
		return this.flightStops;
	}

	INDRA_getCommercialStops() {
		// return this.flight && this.flight.listSegment ? this.flight.listSegment : 0;
		return this.commercialStops.length > 0 ? this.commercialStops : 0;
	}

	INDRA_checkAllStops() {
		// return this.flight && this.flight.listSegment ? this.flight.listSegment : 0;
		if (this.allStops.length > 0) {
			return true;
		} else {
			return false;
		}
	}

	INDRA_getAllStops() {
		// return this.flight && this.flight.listSegment ? this.flight.listSegment : 0;
		return this.allStops;
	}

	getStop(stop) {

		if((stop.stopTime > 0 && !stop.stopover) && (stop.technicalStops != null)){
			return 1;
			
		} else if(stop.stopTime > 0 && !stop.stopover){
			return 2;

		} else if (stop.technicalStops.length > 0) {
			return 3;
		}

		return 2;
	}

	/**
	 * formated formated time
	 * @returns stops object
	 */
	INDRA_printTime(time): String {
		// time in minutes
		const hours = Math.floor(time / 60);
		const minutes = (time % 60);

		const stopTimeHours = hours < 10 ? '0' + hours : hours;
		const stopTimeMinutes = minutes < 10 ? '0' + minutes : minutes;

		return stopTimeHours + 'h' + stopTimeMinutes + 'min';
	}

	/**
	 * Check if flight already has check-in information
	 */
	INDRA_showCheckInInfo() {
		const checkinInfoArr = this.booked_trip['checkin-information'];
		const checkinInfo = checkinInfoArr[this.flight.details.listSegment[0].idInfoSegment];
		if (checkinInfo && checkinInfo.status) {
			return (
				this.booked_trip.data.statusBook.toLowerCase() !== STATUS_BOOK_PENDING_CODE &&
				!this._flight.details.flightFlown &&
				!this.noShow &&
				!this.isCancelledFlight &&
				this.show_check_in &&
				checkinInfo.status.toLowerCase() !== CHECK_IN_STATUS_CLOSED &&
				checkinInfo.status.toLowerCase() !== CHECK_IN_STATUS_INVALID &&
				((!(this.isUnavailableFlight && checkinInfo.status.toLowerCase() === CHECK_IN_STATUS_OPEN) && this.breakdownAPIstatus === 'loaded') // this condition will be considered if breakdown api is ok.
					|| (checkinInfo.status.toLowerCase() !== CHECK_IN_STATUS_OPEN && this.breakdownAPIstatus !== 'loaded') // this condition will be considered if breakdown api encountered an error.
				)
			);
		}

		// this.changeDetector.detectChanges();
		return false;
	}

	INDRA_handleTicketConditionsClick() {
		this.sidebarService.openSidebar([
			'ticket-conditions',
			{
				flight: this.flight.details.assignedFlightId,
				isDupe: this.isDupe
			}
		]);
	}

	/**
	 * Check if flight is cancelled
	 */
	INDRA_cancelledFlight() {
		return this.isCancelledFlight;
	}

	INDRA_handleIncludedPerPassenger() {
		this.sidebarService.openSidebar([
			'passenger-included',
			{ flight: this.flight.details.assignedFlightId, pnr: this.booked_trip.data.pnr }
		]);
	}

	INDRA_handleDetailsFeature(details: { route: string, id: any }) {
		const bookedPnr = this.booked_trip.data.pnr;
		if (details.route == 'passenger-included' && bookedPnr && details.id) {
			this.sidebarService.openSidebar(['passenger-included',
				{ flight: this.flight.details.assignedFlightId, pnr: bookedPnr, id: details.id }]);
		} else {
			this.sidebarService.openSidebar([
				details.route,
				{ flight: this.flight.details.assignedFlightId, brand: this.INDRA_getBrand() }
			]);
		}

	}

	/**
	 * Check if should display extra info
	 */
	INDRA_showExtraInfo() {

		/*
		if (this.isTTTBokingPayment && this.extraInfo)
			return true;
		*/

		return (
			this.isBookingFlow || // should always show when in review flights flow
			(this.booked_trip.data.statusBook.toLowerCase() !== STATUS_BOOK_PENDING_CODE &&
				// TODO !this.booked_trip.is_group && temporarily turned this off to lessend the breaks while models are being updated
				!this._flight.details.flightFlown &&
				!this.noShow &&
				!this.isCancelledFlight)
		);
	}

	INDRA_handleAddFeature(action: any) {
		this.sidebarService.openSidebar([action.route, { flight: this.flight.details.assignedFlightId, aggregateSale: action.aggregateSale }]);
	}

	/**
	 * Check if should upgrade options
	 */
	INDRA_showUpgrade() {
		const brand = this.INDRA_getBrand();
		const isTapCarrier = this.bookingService.INDRA_hasTapOperatedSegment(this.flight.details.listSegment);
		return (
			this.upgradeInfo &&
			// this.booked_trip.data.statusBook.toLowerCase() !== STATUS_BOOK_PENDING_CODE &&
			(this.options && this.options.upgrade.length) > 0 &&
			!this._flight.details.flightFlown &&
			!this.noShow &&
			!this.isCancelledFlight &&
			brand !== BRAND_CODE_TOP_EXECUTIVE &&
			!this.plusgradeFlag &&
			!this.hasUnaccompaniedMinor &&
			!this.IfAllPassengersAreChildren &&
			!this.INDRA_segmentHasTrainBus() &&
			isTapCarrier

		);
	}

	/**
	 * Check if should display change/cancel options
	 */
	INDRA_showEditChange() {
		return (
			this.editOrChangeInfo &&
			// this.booked_trip.data.statusBook.toLowerCase() !== STATUS_BOOK_PENDING_CODE &&
			(this.options && this.options.change_cancel.length > 0) &&
			!this._flight.details.flightFlown &&
			!this.noShow &&
			!this.isCancelledFlight
		);
	}

	/**
	 * Check if flight is flown
	 */
	INDRA_flownFlight() {
		return this._flight ? this._flight.details.flightFlown : false;
	}

	/**
	 * Check if any of the segment in the flight is a no-show
	 */
	INDRA_noShowFlight() {
		return this.noShow;
	}

	INDRA_getCheckinDetails() {
		const details = {};
		const checkinInfoArr = this.booked_trip['checkin-information'];
		const checkinInfo = checkinInfoArr[this.flight.details.listSegment[0].idInfoSegment];
		if (checkinInfo && checkinInfo.date) {
			details['time'] = checkinInfo.date;
		}
		if (checkinInfo && checkinInfo.status) {
			details['status'] = checkinInfo.status.toLowerCase();
		}
		return details;
	}

	INDRA_ariaLabelFlightStops() {
		let label = '';

		// label += 'List with flight stops.';
		// label += 'This flight has ' + this.flightStops.length;
		label += this.INDRA_getTextTranslation('bookingDetails.aria.listWithFlightStops');
		label += this.INDRA_getTextTranslation('bookingDetails.aria.thisFlightHas') + this.flightStops.length;
		if (this.flightStops.length === 1) {
			label += this.INDRA_getTextTranslation('bookingDetails.aria.stop');
		} else {
			label += this.INDRA_getTextTranslation('bookingDetails.aria.stops');
		}
		return label;
	}

	INDRA_getBrand() {
		if (!this.flight.details.fareFamily) {
			return '';
		} else {
			if (this.isBookingFlow) {
				return this.bookingSearchService.INDRA_getBrandCodeFromAmadeus(this.flight.details.fareFamily);
			} else {
				return this.bookingService.INDRA_getBrandCode(this.flight.details.fareFamily);
			}
		}
	}

	INDRA_getTranslation(key: string): Observable<string> {
		return this.ibeAdminService.getTranslationValueAsync(key);
	}
	INDRA_getTextTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_updateIncludedFeaturesWithPurchasedFeature() {
		let purchasedFeature = null;
		const segmentIDs = this.INDRA_getSegmentIDs();
		if (this.booked_trip.data.ancillaries.ancillaries) {
			this.booked_trip.data.ancillaries.ancillaries.forEach(ancillary => {
				ancillary.journey.forEach(journeyItem => {
					if (journeyItem.flightId === this._flight.details.idFlight.toString() && segmentIDs.includes(journeyItem.segmentId)) {
						journeyItem.passengers.forEach(pax => {
							pax.ancillaryInfo.forEach(ancillaryInfoItem => {

								if (ANCILLARIES_INELIGIBLE_FOR_CHANGE.includes(ancillaryInfoItem.code)) {
									this.isEligibleForUpdateOrChange = false;
								}

								// skip ancillary items that belongs to the ignore list.
								if (!this.ignoredAncillaryList.includes(ancillaryInfoItem.code)) {
									purchasedFeature = INDRAFeature.createByCode(ancillaryInfoItem.code, (this.isBookingFlow && !this.isBookingViewFlow));
									// tslint:disable-next-line:radix
									const ancillaryStatus = parseInt(ancillaryInfoItem.status);
									if (!purchasedFeature.unconfirmed) {
										purchasedFeature = Object.assign({}, purchasedFeature, { unconfirmed: [] });
									}
									if (purchasedFeature.icon != 'general--not_available') {
										const labelKey = `${TRANSLATION_ANCILLARY_GROUP + ancillaryInfoItem.code}`;
										purchasedFeature.label = this.INDRA_getTranslation(labelKey);
										purchasedFeature.details.label = this.INDRA_getTranslation('bookingDetails.link.learnMore');
									} else {
										purchasedFeature.label = new BehaviorSubject(purchasedFeature.label);
										purchasedFeature.details.label = this.INDRA_getTranslation('bookingDetails.link.learnMore');
									}

									if (!this.includedFeaturesIcons.includes(purchasedFeature.icon) || purchasedFeature.icon === 'general--not_available') {
										this.includedFeaturesIcons.push(purchasedFeature.icon);
										if (!purchasedFeature.unconfirmed.includes(ancillaryStatus)) {
											if (UNCONFIRMED_CODES.includes(ancillaryStatus)) {
												purchasedFeature.unconfirmed.push(ancillaryStatus);
											}
										}
										this.included_features.push(purchasedFeature);
									} else if (this.includedFeaturesIcons.includes(purchasedFeature.icon)) {
										if (UNCONFIRMED_CODES.includes(ancillaryStatus)) {
											const ancillaryIndex = this.included_features.findIndex((feature) => {
												return feature.icon === purchasedFeature.icon;
											});
											if (!this.included_features[ancillaryIndex].unconfirmed.includes(ancillaryStatus)) {
												this.included_features[ancillaryIndex].unconfirmed.push(ancillaryStatus);
											}
										}
									}
								}

								// this detects if the flight has a plusgade ancillary.
								if (ancillaryInfoItem.code === SSR_CODE_PLUSGRADE) {
									this.plusgradeFlag = true;
								}
							});
						});
					}
				});
			});
		}
	}

	INDRA_getSegmentIDs(): string[] {
		return this.flight.details.listSegment.map(segment => segment.idInfoSegment + '');
	}

	INDRA_updateIncludedFeaturesWithSeats() {
		let purchasedFeature = null;
		const segmentIDs = this.INDRA_getSegmentIDs();
		if (this.booked_trip.data.ancillaries.seat) {
			this.booked_trip.data.ancillaries.seat.journey.forEach(seat => {
				if (seat) {
					if (seat.flightId === this._flight.details.idFlight.toString() && segmentIDs.includes(seat.segmentId)) {
						seat.passengers.forEach(pax => {
							pax.ancillaryInfo.forEach(seatInfoItem => {
								if (seatInfoItem.code === SSR_CODE_SEAT) {
									purchasedFeature = INDRAFeature.createByCode(seatInfoItem.code, (this.isBookingFlow && !this.isBookingViewFlow && !this.isTimeToThinkCompletionFlow));
									const labelKey = `${TRANSLATION_ANCILLARY_GROUP + seatInfoItem.code}`;
									purchasedFeature.label = this.INDRA_getTranslation(labelKey);
									purchasedFeature.details.label = this.INDRA_getTranslation('bookingDetails.link.learnMore');
									if (!this.includedFeaturesIcons.includes(purchasedFeature.icon) || purchasedFeature.icon === 'general--not_available') {
										this.includedFeaturesIcons.push(purchasedFeature.icon);
										this.included_features.push(purchasedFeature);
									}
								}
							});
						});
					}
				}
			});
		}
	}

	INDRA_updateIncludedFeaturesWithPRM() {
		let purchasedFeature = null;
		const segmentIDs = this.INDRA_getSegmentIDs();
		const listPax = this.booked_trip.data.infoPax.listPax;
		this.IfAllPassengersAreChildren = this.bookingService.INDRA_checkIfAllPassengersAreChildren(listPax);
		let unAccompaniedMinorCount = 0;
		this.booked_trip.data.infoPax.listPax.forEach(pax => {
			let isUnaccompaniedMinor = false;
			if (pax.prm) {
				pax.prm.forEach(
					prm => {
						// used to check if prm contains certain ancillaries that
						// makes flight ineligible for change and update
						if (ANCILLARIES_INELIGIBLE_FOR_CHANGE.includes(prm.type)) {
							this.isEligibleForUpdateOrChange = false;
						}
						purchasedFeature = INDRAFeature.createByCode(prm.type, (this.isBookingFlow && !this.isBookingViewFlow && !this.isTimeToThinkCompletionFlow));
						const labelKey = `${TRANSLATION_ANCILLARY_GROUP + prm.type}`;
						purchasedFeature.label = this.INDRA_getTranslation(labelKey);
						purchasedFeature.details.label = this.INDRA_getTranslation('bookingDetails.link.learnMore');
						if (!purchasedFeature.unconfirmed) {
							purchasedFeature.unconfirmed = [];
						}
						if (!this.includedFeaturesIcons.includes(purchasedFeature.icon) || purchasedFeature.icon === 'general--not_available') {
							if (!this.ignoredAncillaryList.includes(prm.type)) {
								if (!this.tmp_pmrAncillaryList.includes(prm.type)) {
									this.includedFeaturesIcons.push(purchasedFeature.icon);
									this.tmp_pmrAncillaryList.push(prm.type);
									// tslint:disable-next-line:radix
									const statusCode = parseInt(prm.status);
									if (!purchasedFeature.unconfirmed.includes(statusCode)) {
										if (UNCONFIRMED_CODES.includes(statusCode)) {
											purchasedFeature.unconfirmed.push(statusCode);
										}
									}
									this.included_features.push(purchasedFeature);
								}
							}
						} else if (this.includedFeaturesIcons.includes(purchasedFeature.icon)) {
							// tslint:disable-next-line:radix
							const statusCode = parseInt(prm.status);
							if (UNCONFIRMED_CODES.includes(statusCode)) {
								const ancillaryIndex = this.included_features.findIndex((feature) => {
									return feature.icon === purchasedFeature.icon;
								});
								if (!this.included_features[ancillaryIndex].unconfirmed.includes(statusCode)) {
									this.included_features[ancillaryIndex].unconfirmed.push(statusCode);
								}
							}
						}

						// this detects if the flight has unaccompanied minor.
						if (SSR_CODE_UNACCOMPANIED_MINOR == prm.type) {
							this.hasUnaccompaniedMinor = true;
							isUnaccompaniedMinor = true;
						}

						// this detects if the flight has unaccompanied minor.
						if (SSR_CODE_FREQUENT_TRAVELLER_MILES_PROGRAM_REDEMPTION == prm.type) {
							this.isAwardTicket = true;
						}
					}
				);
			}

			if (isUnaccompaniedMinor) {
				unAccompaniedMinorCount++;
			}
		});

		if (unAccompaniedMinorCount === listPax.length) {
			this.allAreUnaccompaniedMinor = true;
		}
	}

	INDRA_updateIncludedFeaturesWithMilesAndFFProgram() {
		let includedFeature = null;
		const passengers = this.bookingService.INDRA_getPaxInfo();
		const fareInformation = this.booked_trip['fare-information'];
		const flightIdfareInformation: INDRAFareInformation = fareInformation[this.flight.details.idFlight];

		// miles will be displayed only on the first card created for the flight id.
		// let firstCardOfTheFlightFlag = this.bookingService.INDRA_checkFlightCardIfFirstCardOfTheFlight(this.flight.details.assignedFlightId, this.flight.details.idFlight);

		// Miles earned display for the flight
		if (flightIdfareInformation) {
			if (flightIdfareInformation.miles && !this.isAwardTicket) {
				/**
				 *	Compute for the Miles to be displayed. For cases wherein there are multiple passengers
				 *	with different tier level, the miles will be computed for the highest tier level.
				 *	If all passengers are not FF members, miles will be returned as is from the fare information.
				 **/
				const tierLevel = this.INDRA_determineHighestPassengerTierLevel(passengers);
				let miles = 0;
				if (tierLevel) {
					miles = this.bookingService.INDRA_getLoyaltyMilesPerTierByFlightCardId(this.flight.details.idFlight, tierLevel, this.flight.details.assignedFlightId);
				} else {
					miles = this.bookingService.INDRA_getLoyaltyMilesByFlightCardId(this.flight.details.idFlight, this.flight.details.assignedFlightId);
				}
				includedFeature = INDRAFeature.getLoyaltyMiles(miles.toString(), (this.isBookingFlow && !this.isBookingViewFlow && !this.isTimeToThinkCompletionFlow));
				includedFeature.details.label = this.INDRA_getTranslation('bookingDetails.link.learnMore');
				includedFeature.label = this.INDRA_getTranslation(TRANSLATION_ANCILLARY_GROUP + 'miles');
				this.included_features.push(includedFeature);
			}
		}

		// FF Program display per applicable user
		if (passengers.length > 0) {
			passengers.forEach(pax => {
				if (pax.tierLevelFF) {
					let tierLevel = null;
					tierLevel = INDRAFeature.getFFTierLevel(pax.tierLevelFF, pax);
					tierLevel.details.label = this.INDRA_getTranslation('bookingDetails.link.viewAllBenefits');
					// tierLevel.valueLabel += ' ' + this.INDRA_getTextTranslation('bookingDetails.label.isA');
					const label = this.INDRA_getTranslation(TRANSLATION_ANCILLARY_GROUP + (pax.tierLevelFF == 'MILES' ? pax.tierLevelFF + 'member' : pax.tierLevelFF));
					tierLevel.label = label;
					this.included_features.push(tierLevel);
				}
			});
		}
	}

	INDRA_determineHighestPassengerTierLevel(passengers) {
		let tierLevel;
		let highestTierLevelIndex = -1;
		if (passengers && passengers.length > 0) {
			passengers.forEach(pax => {
				if (pax.tierLevelFF) {
					const paxTierLevelIndex = TAP_MILES_AND_GO_FF_TIER_LEVELS_HIERARCHY.indexOf(pax.tierLevelFF);
					if (highestTierLevelIndex === -1 || (paxTierLevelIndex !== -1 && paxTierLevelIndex < highestTierLevelIndex)) {
						tierLevel = pax.tierLevelFF;
						highestTierLevelIndex = paxTierLevelIndex;
					}
				}
			});
		}
		return tierLevel;
	}

	INDRA_showUpgradeWithMiles(flightId: string) {
		let flag = false;

		const fareInformation = this.booked_trip['fare-information'];
		const flightIdfareInformation: INDRAFareInformation = fareInformation[flightId];

		if (flightIdfareInformation) {
			if (flightIdfareInformation.ancillaries.includes(SSR_CODE_MILES_UPGRADE)) {
				flag = true;
			}
		}
		return flag;
	}

	INDRA_showUpgradeWithPlusGrade() {
		// TODO
		return false;
	}

	INDRA_hasPurchasedAncillaries() {
		return (this.booked_trip.data.ancillaries.ancillaries &&
			this.booked_trip.data.ancillaries.ancillaries.length > 0 ? true : false);
	}

	INDRA_handleSelectNewFlight() {
		return false;
	}

	INDRA_getExtrasPurchased() {
		const featureList = [];

		const segmentIDs = this.INDRA_getSegmentIDs();
		if (this.booked_trip.data.ancillaries.ancillaries) {
			this.booked_trip.data.ancillaries.ancillaries.forEach(ancillary => {
				ancillary.journey.forEach(journeyItem => {
					if (journeyItem.flightId === this._flight.details.idFlight.toString() && segmentIDs.includes(journeyItem.segmentId)) {
						journeyItem.passengers.forEach(pax => {
							pax.ancillaryInfo.forEach(ancillaryInfoItem => {
								let purchasedFeature = null;
								// skip ancillary items that belongs to the ignore list.
								if (!this.ignoredAncillaryList.includes(ancillaryInfoItem.code)) {
									purchasedFeature = INDRAFeature.createByCode(ancillaryInfoItem.code, (this.isBookingFlow && !this.isBookingViewFlow && !this.isTimeToThinkCompletionFlow));
									// tslint:disable-next-line:radix
									const ancillaryStatus = parseInt(ancillaryInfoItem.status);
									if (!purchasedFeature.unconfirmed) {
										purchasedFeature = Object.assign({}, purchasedFeature, { unconfirmed: [] });
									}
									purchasedFeature.quantity = ancillaryInfoItem['quantity'];
									const labelKey = `${TRANSLATION_ANCILLARY_GROUP + ancillaryInfoItem.code}`;
									this.translationSubscription1 = this.INDRA_getTranslation(labelKey).subscribe(data => {
										purchasedFeature.label = new BehaviorSubject(`${purchasedFeature.quantity}x ${data}`);
									});
									delete purchasedFeature.details;
									const feautureExist = featureList.filter((item) => item.id === purchasedFeature.id);
									if (feautureExist.length === 0) {
										if (purchasedFeature.icon != 'general--not_available') {
											// tslint:disable-next-line:no-shadowed-variable
											const labelKey = `${TRANSLATION_ANCILLARY_GROUP + ancillaryInfoItem.code}`;
											this.translationSubscription2 = this.INDRA_getTranslation(labelKey).subscribe(data => {
												purchasedFeature.label = new BehaviorSubject(`${purchasedFeature.quantity}x ${data}`);
											});

										} else {
											purchasedFeature.label = new BehaviorSubject(purchasedFeature.label);
										}
										featureList.push(purchasedFeature);
									} else {
										feautureExist[0].quantity = feautureExist[0].quantity + purchasedFeature.quantity;
										// tslint:disable-next-line:no-shadowed-variable
										const labelKey = `${TRANSLATION_ANCILLARY_GROUP + ancillaryInfoItem.code}`;
										Promise.all([
											this.translationSubscription3 = this.INDRA_getTranslation(labelKey).subscribe(
												res => {
													feautureExist[0].label = new BehaviorSubject(`${feautureExist[0].quantity}x ${res}`);
												}
											)
										]);
									}
								}
							});
						});
					}
				});
			});
		}

		this.allSubscriptions.push(this.translationSubscription1);
		this.allSubscriptions.push(this.translationSubscription2);
		this.allSubscriptions.push(this.translationSubscription3);
		this.extra_features_purchased = featureList;
	}

	INDRA_checkIfAllPassengersAlreadyPurchasedForAncillaryGroup(ancillaryGroupCode: string) {
		let flag = false;
		const paxWithPetPurchases: string[] = [];
		const group = this.bookingService.INDRA_getSSRAvailableForGroup(ancillaryGroupCode);
		const segmentIDs = this.INDRA_getSegmentIDs();
		if (this.booked_trip.data.ancillaries.ancillaries) {
			this.booked_trip.data.ancillaries.ancillaries.forEach(ancillary => {
				ancillary.journey.forEach(journeyItem => {
					if (journeyItem.flightId === this._flight.details.idFlight.toString() && segmentIDs.includes(journeyItem.segmentId)) {
						journeyItem.passengers.forEach(pax => {
							pax.ancillaryInfo.forEach(ancillaryInfoItem => {
								if (group.includes(ancillaryInfoItem.code) && !paxWithPetPurchases.includes(pax.paxId)) {
									paxWithPetPurchases.push(pax.paxId);
								}
							});
						});
					}
				});
			});
		}
		if (this.booked_trip.data.infoPax.listPax.length === paxWithPetPurchases.length) {
			flag = true;
		}
		return flag;
	}

	INDRA_isPresentOnFareInformation(CODE) {
		return this.bookingService.INDRA_isPresentOnFareInformation(CODE, this.flight.details.idFlight);
	}

	INDRA_isPassengerPresentOnTierLevel(CODE) {
		return this.bookingService.INDRA_isPassengerPresentOnTierLevel(CODE, this.booked_trip.data.infoPax.listPax);
	}

	INDRA_getPassengersTierBenefits() {
		let includedFeature = null;

		const tierInformation = this.booked_trip['tier-information'];
		if (tierInformation) {
			const listPax = this.booked_trip.data.infoPax.listPax;
			listPax.forEach(paxInfo => {
				if (paxInfo.tierLevelFF) {
					const tierKey = paxInfo.tierLevelFF;
					const tierBenefits = tierInformation[tierKey];
					if (tierKey && tierBenefits && tierBenefits.ancillaries && tierBenefits.ancillaries.length > 0) {
						tierBenefits.ancillaries.forEach(ancillaryBenefit => {
							if (!this.ignoredAncillaryList.includes(ancillaryBenefit)) {
								includedFeature = INDRAFeature.createByCode(ancillaryBenefit, (this.isBookingFlow && !this.isBookingViewFlow && !this.isTimeToThinkCompletionFlow));
								if (!includedFeature.unconfirmed) {
									includedFeature = Object.assign({}, includedFeature, { unconfirmed: [] });
								}

								if (includedFeature.icon != 'general--not_available') {
									const labelKey = `${TRANSLATION_ANCILLARY_GROUP + ancillaryBenefit}`;
									includedFeature.label = this.INDRA_getTranslation(labelKey);
									includedFeature.details.label = this.INDRA_getTranslation('bookingDetails.link.learnMore');
								} else {
									includedFeature.label = new BehaviorSubject(includedFeature.label);
									includedFeature.details.label = this.INDRA_getTranslation('bookingDetails.link.learnMore');
								}

								if (!this.includedFeaturesIcons.includes(includedFeature.icon) || includedFeature.icon === 'general--not_available') {
									if (ancillaryBenefit === SSR_CODE_PREMIUM_CUSTOMER_CENTER) {
										if (this.INDRA_getBrand() === BRAND_CODE_TOP_EXECUTIVE || this.INDRA_getBrand() === BRAND_CODE_EXECUTIVE) {
											for (const segment of this.flight.details.listSegment) {
												if (segment.departureAirport === LISBON_CODE) {
													this.includedFeaturesIcons.push(includedFeature.icon);
													this.included_features.push(includedFeature);
													break;
												}
											}
										}
									} else {
										this.includedFeaturesIcons.push(includedFeature.icon);
										this.included_features.push(includedFeature);
									}
								}
							}
						});
					}
				}
			});
		}
	}

	/** Hide fare conditions sidebar route if not gds office, group, or awardTicket */
	INDRA_showFareConditions() {
		const booked_trip = this.booked_trip;
		const isGroup = booked_trip['data']['group'] ? booked_trip['data']['group'] : false;
		const office = booked_trip['data']['office'] ? booked_trip['data']['office'] : '';
		const isStaff = this.INDRA_isStaff(booked_trip);
		const isITFare = this.INDRA_isITFare(booked_trip);
		if (!this.isBookingFlow &&
			(this.isAwardTicket || isGroup || isStaff || isITFare || !this.bookingService.INDRA_isTAPGDSOffice(office))) {
			return false;
		} else {
			return true;
		}
	}

	/** Checks if PNR is staff */
	INDRA_isStaff(bookedTrip: INDRABookedTripDetails) {
		const passengers = bookedTrip.data.infoPax && bookedTrip.data.infoPax.listPax ? bookedTrip.data.infoPax.listPax : [];
		let isStaff = false;
		if (passengers.length > 0) {
			passengers.forEach(passenger => {
				if (passenger && passenger.staff) {
					isStaff = true;
				}
			});
		}
		return isStaff;
	}

	/** Checks if PNR is IT Fare */
	INDRA_isITFare(booked_trip) {
		const fare = booked_trip.data && booked_trip.data.fare ? booked_trip.data.fare : null;
		if (fare && fare.flightPrice) {
			if (fare.flightPrice.totalPrice) {
				if (fare.flightPrice.totalPrice.basePrice || fare.flightPrice.totalPrice.price) {
					return false;
				}
			}
		}
		return true;
	}

	INDRA_initializeTotalSummarySubscription() {
		this.loadingTotalSummarySubscription = this.totalSummaryService.INDRA_getLoadingTotalSummary().subscribe(
			flag => {
				if (flag) {
					this.breakdownAPIstatus = flag;
					// this.changeDetector.detectChanges();
				}
			}
		);
		this.currentTotalSummarySubscription = this.totalSummaryService.INDRA_getObservableTotalSummary().subscribe(
			data => {
				if (data) {
					this.totalSummary = data;
					this.isUnavailableFlight = this.INDRA_isUnavailableFlight(this.flight.details.idFlight);
					if (this.isUnavailableFlight) {
						this.INDRA_refreshUpgradeChangeOptions();
					}
				}
			}
		);
		this.allSubscriptions.push(this.loadingTotalSummarySubscription);
		this.allSubscriptions.push(this.currentTotalSummarySubscription);
	}


	INDRA_isUnavailableFlight(flightId) {

		let unavailableFlight = false;
		let flightCtr = 0;
		if (this.totalSummary && this.totalSummary['flagged-flights']) {
			const flaggedFlights = this.totalSummary['flagged-flights'];
			const listPax = this.booked_trip.data.infoPax.listPax;
			listPax.forEach(paxInfo => {
				const idPax = paxInfo.idPax.toString();
				if (flaggedFlights[idPax] && flaggedFlights[idPax].length > 0) {
					const hasFlight = flaggedFlights[idPax].includes(flightId.toString());
					if (hasFlight) {
						flightCtr++;
					}
				}
			});
		}

		if (flightCtr > 0) {
			unavailableFlight = true;
		}

		return unavailableFlight;
	}

	INDRA_refreshUpgradeChangeOptions() {
		this.options.upgrade = [];
		const changeCancelOptions = this.options.change_cancel;
		if (changeCancelOptions && changeCancelOptions.length > 0) {
			const changeFlightIdx = changeCancelOptions.findIndex(option => option.link.includes('/my-bookings/change-flight/search/' + this.booked_trip.data.pnr));
			if (changeFlightIdx > -1) {
				changeCancelOptions.splice(changeFlightIdx, 1);
			}

		}

	}

	INDRA_returnAltTranslation() {
		return this.INDRA_getTextTranslation('bookingDetails.alt.flightWith') + ' ' + this.INDRA_getBrand() + ' ' + this.INDRA_getTextTranslation('bookingDetails.alt.flightFare');
	}

	INDRA_getNextSegmentAfterStop(stopSegmentId) {
		const segmentIndex = this.flight.details.listSegment.findIndex(segment => segment.idInfoSegment === stopSegmentId);
		if (segmentIndex >= 0) {
			const segment = this.flight.details.listSegment[segmentIndex + 1];
			return segment ? segment : null;
		}
		return null;
	}

	INDRA_printChangeEquipment(stopIndex) {
		const currentStop = this.flightStops[stopIndex];
		const nextSegment = this.INDRA_getNextSegmentAfterStop(currentStop.idInfoSegment);
		if (nextSegment) {
			if (currentStop.equipment === EQUIPMENT_CODE_BUS) {
				if (nextSegment.equipment !== EQUIPMENT_CODE_BUS && nextSegment.equipment !== EQUIPMENT_CODE_TRAIN) {
					return 'bookingDetails.text.changeToPlane';
				}
			} else {
				if (nextSegment.equipment === EQUIPMENT_CODE_BUS) {
					return 'bookingDetails.text.changeToBus';
				}
			}
		}
		return '';
	}

	INDRA_nextSegmentHasBusStop(stopIndex) {
		const currentStop = this.flightStops[stopIndex];
		const nextSegment = this.INDRA_getNextSegmentAfterStop(currentStop.idInfoSegment);
		return (nextSegment && nextSegment.busStop);
	}

	INDRA_printHopDetails(stopIndex) {
		const currentStop = this.flightStops[stopIndex];

		if (currentStop.busStop) {
			return 'busStops.label.' + currentStop.busStop.ibeAdminKey.replace('KEY_', '').replace('_', '');
		} else {
			const nextSegment = this.INDRA_getNextSegmentAfterStop(currentStop.idInfoSegment);
			if (nextSegment && nextSegment.equipment === EQUIPMENT_CODE_BUS && nextSegment.busStop) {
				return 'busStops.label.' + nextSegment.busStop.ibeAdminKey.replace('KEY_', '').replace('_', '');
			}
		}
		return '';
	}

	INDRA_expand() {
		if (this.expanded !== '')
			return this.expanded;
		return 'expanded';

		/*
			// client change post Sprint 8:
			if (this.booked_trip.status === 'ssrec')
				return 'expanded';
			if (this.expanded !== '')
				return this.expanded;
			return 'collapsed';
		*/
	}

	INDRA_getTimeInfo() {
		this.time_to_flight = this.flight.details.listSegment[0].departureHours*3600;
		this.flightDate = this.INDRA_printFlightDate(this._flight);
		this.timeUnitValue = this.INDRA_printTimeTo();
		this.timeUnitKey = this.INDRA_getTimeUnitKey(this.time_to_flight);
		this.showTimeInfo = true;
		this.cd.detectChanges();
	}

	INDRA_printImage() {
		const IMAGE = 'arrow-bundle-card.svg';
		return 'url(assets/images/ancillaries/packs/' + IMAGE + ')';
	}
	
	INDRA_handleOpenPack(pack) {
		this.sidebarService.openSidebar(["packs",
			{
				flight: this.flight.details.assignedFlightId,
				packId: pack
			}
		]);
	}

	INDRA_getPackSegments(type: string) {
		let packsPerSegment = [];
		this.flight_packs.forEach(pack => {
			if (pack.type === type) {
				packsPerSegment.push(pack);
			}
		})

		return packsPerSegment;
	}

	isDisabled(pack) {
		const isDisabled = this.disabledPacks && this.disabledPacks.length > 0 && this.disabledPacks.includes(pack);

		return isDisabled;
	}
}
